import React, { useEffect, useState } from "react";
import Loader from "../../Components/Loader";
import { useGalleryStore } from "../../store/useGalleryStore";

const GalleryImageUpload = ({ id, imageId, handleCancel, setOpen }) => {
    const { registergalleryimage, getGalleryImageById } = useGalleryStore();
    const [data, setData] = useState({
        image: null,
        isFeatured: true,
        order: null,
    });
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setData((prev) => ({ ...prev, image: file }));
            setPreview(URL.createObjectURL(file));
        }
    };

    const handleSubmit = async () => {
        try {
            setLoading(true)
            const res = await registergalleryimage(data, imageId, id)
            setLoading(false)
            setOpen(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    };

    const getNewOrder = () => {
        const result = getGalleryImageById(id, imageId);
        if (!result) return;

        const { selectedImage, imageLength } = result;

        if (!selectedImage)
            setData((prev) => ({
                ...prev,
                order: imageLength,
            }));
        else {
            setData((prev) => ({
                ...prev,
                order: selectedImage?.order,
                image: selectedImage?.imageLink,
                isFeatured: selectedImage?.isFeatured
            }));
            setPreview(selectedImage?.imageLink)
        }
    };


    useEffect(() => {
        getNewOrder();
    }, [id]);

    return (
        <div
            id="image-upload-section"
            className="bg-white rounded-md shadow-sm border border-neutral-200 overflow-hidden mb-6"
        >
            <div className="px-6 py-4 border-b border-neutral-200 bg-neutral-50">
                <h3>{id ? "Edit Gallery Image" : "Add New Gallery Image"}</h3>
            </div>

            <Loader loading={loading}>
                <div className="p-6">
                    <div className="grid grid-cols-1 gap-6">
                        {/* === Image Upload === */}
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">
                                Upload Image
                            </label>
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                className="w-full border border-neutral-300 rounded-md p-2 text-sm"
                            />
                            {preview && (
                                <img
                                    src={preview}
                                    alt="Preview"
                                    className="mt-4 w-40 h-40 object-cover rounded-md border"
                                />
                            )}
                        </div>

                        {/* === Status === */}
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2">
                                Status
                            </label>
                            <select
                                name="isFeatured"
                                value={data.isFeatured}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            >
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>

                        {/* === Order === */}
                        <div>
                            <label className="block text-sm text-neutral-700 mb-2 mt-3">
                                Image Order
                            </label>
                            <input
                                type="text"
                                name="order"
                                value={data.order}
                                onChange={handleChange}
                                className="w-full px-3 py-2 border border-neutral-300 rounded-md focus:outline-none focus:ring-2 focus:ring-neutral-400"
                            />
                        </div>
                    </div>

                    {/* === Buttons === */}
                    <div className="flex justify-end space-x-3 mt-8">
                        <button
                            className="px-4 py-2 border border-neutral-300 text-neutral-700 rounded-md"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-4 py-2 bg-neutral-900 text-white rounded-md"
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </div>
            </Loader>
        </div>
    );
};

export default GalleryImageUpload;
